import React from "react";
import { connect } from "react-redux";
import { setBtaxData } from "../Actions/btaxActions";

function BtaxAdapter(props) {
  window.addEventListener("message", handleBtaxIncomingData);
  return <h1>Loading...</h1>;

  function handleBtaxIncomingData(message) {
    // TODO - IMPORTANT!!! change to -> https://b-tax-apps.co.il
    if (message.origin == "http://localhost:48739") {
      props.setBtaxData(message.data).then(() => {
        setTimeout(() => {
          redirectUser();
        }, 5000);
      });
    }
  }

  function redirectUser() {
    window.removeEventListener("message", handleBtaxIncomingData);
    var isLoggedIn = localStorage.getItem("isLoggedin");
    if (isLoggedIn) {
      props.history.push("/deals");
    } else {
      props.history.push("/login");
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setBtaxData: (btaxData) => dispatch(setBtaxData(btaxData))
  };
};

export default connect(null, mapDispatchToProps)(BtaxAdapter);
